(function () {
  function fetchProducts() {
    const element = document.querySelector('.recently-viewed-products');
    const options = JSON.parse(element.getAttribute('data-section-settings'));
    const queryString = getSearchQueryString(options);

    const fetchUrl = new URL(`${window.shopUrl}${window.routes.search_url}`);
    fetchUrl.searchParams.append('section_id', element.getAttribute('data-section-id'));
    fetchUrl.searchParams.append('type', 'product');
    fetchUrl.searchParams.append('q', queryString);
    if(window.cobrand) fetchUrl.searchParams.append('view', window.cobrand.template);

    fetch(fetchUrl.href, {
      credentials: 'same-origin',
      method: 'GET',
    }).then(function (response) {
      response.text().then(function (content) {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = content;

        const swiperPlaceHolder = element.querySelector('.recently-viewed-products-placeholder');
        const newSwiperComponent= tempElement.querySelector('swiper-component');

        if(newSwiperComponent && swiperPlaceHolder) {
          const cardsCount=  newSwiperComponent.querySelectorAll('.swiper-slide').length;
          swiperPlaceHolder.appendChild(newSwiperComponent);

          if(cardsCount > 0) element.parentNode.style.display = 'block';
          else element.parentNode.remove();
        }
      });
    });
  };

  function getSearchQueryString(options) {
    let items = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.recentlyViewedProducts) || '[]');

    items = items.filter(item => item !== options['currentProductId']);
    return items.map(item => `id:${item}`).join(' OR ');
  }

  fetchProducts();
})();
